var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',_vm._l((_vm.count),function(i){return _c('SettingsSection',{key:i},[_c('SettingsSectionTitle',[_c('Skeleton',{attrs:{"width":"200px"}})],1),_vm._v(" "),_c('Skeleton',{attrs:{"count":6}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }